module.exports = __webpack_public_path__ + "img/vswiper5.9b3e19b1.png";